export const Progress = ({ children, progress = 0 }) => {
  return (
    <div className="flex-1 bg-gray-200 rounded-full h-1.5 dark:bg-gray-700">
      <div
        className="bg-blue-600 h-1.5 rounded-full dark:bg-blue-500"
        style={{
          width: progress + "%",
        }}
      ></div>
    </div>
  );
};
